import styled from 'styled-components'

const Nav = styled.nav`
  ul {
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    overflow: hidden;
    max-width: 400px;
    margin: 1em auto;
    width: 100%;
    text-align: center;
    li {
      list-style: none;
      :first-child a,
      :first-child span {
        margin-left: 0;
        margin-right: 0;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
      }
      :last-child a,
      :last-child span {
        margin-left: -1px;
        margin-right: 0;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
      }
      a,
      span {
        padding: 0.5em 0.9em;
        color: #a1a2d1;
        text-decoration: none;
        font-size: 0.8em;
        display: block;
        border: 1px solid #a1a2d1;
        margin-left: -1px;
        box-sizing: border-box;
      }
      a {
        :hover {
          background: #dcdce9;
        }
      }
      a.ativa,
      span.ativa {
        background-color: #a1a2d1;
        color: #ffffff;
      }
    }
  }
`

export default Nav
